//  key
export const LOCALE_KEY = 'LOCALE__';

export enum Authority {
    ADMIN = 'ROLE_ADMIN',
    USER = 'ROLE_USER'
}
